import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const DateTimeSelector = (props) => {
    const { t } = useTranslation();
    const { setSelectedDate, startDate, endDate } = props;
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const stepMinutes = 30; // Co pół godziny

    // Obsługa zmiany wartości suwaka
    const handleRangeChange = (event) => {
        setSelectedIndex(Number(event.target.value));
        setSelectedDate(timeSlots[selectedIndex].format("YYYY-MM-DD HH:mm"));
    };

    useEffect(() => {
        if (timeSlots.length > 0) {
            setSelectedIndex(timeSlots.length - 1);
            setSelectedDate(timeSlots[selectedIndex] /* .format("YYYY-MM-DD HH:mm") */);
        }
        // eslint-disable-next-line
    }, [timeSlots]);

    useEffect(() => {
        const timeS = [];
        // Generowanie tablicy dat i godzin co 30 minut
        let current = startDate.clone();
        while (current <= endDate) {
            timeS.push(current.clone());
            current.add(stepMinutes, "minutes");
        }
        setTimeSlots(timeS);
        // eslint-disable-next-line
    }, []);

    return (
        <Form.Group className="my-3">
            <Form.Label>
                {t("classes.howLongWillYouWait")} <span className="req">*</span>
            </Form.Label>
            {timeSlots.length > 0 && selectedIndex && (
                <>
                    <Form.Range
                        min={1}
                        max={timeSlots.length - 1}
                        value={selectedIndex}
                        onChange={handleRangeChange}
                        step={1} // Każdy krok odpowiada jednemu przedziałowi 30 minut
                    />
                    <p className="mb-3">
                        {t("chosenDate")}: <span className="text-bold">{timeSlots[selectedIndex].format("YYYY-MM-DD HH:mm")}</span>
                    </p>
                </>
            )}
        </Form.Group>
    );
};

export default DateTimeSelector;
